import React from 'react';
import { SearchOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Select } from 'syngenta-digital-cropwise-react-ui-kit';
import './styles.less';
import { AppConstants } from 'core/app.constants';
import { useMediaQuery } from 'react-responsive';
import { Tooltip } from 'antd';

const { Option } = Select;
interface LocationOfResidenceDropdownPropsComponent {
  t: any;
  onCountrySelect: any;
  currentCountry: string;
}

export const LocationOfResidenceDropdownComponent = (props: LocationOfResidenceDropdownPropsComponent) => {
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 });
  return (
    <div className={!isDesktopOrLaptop ? 'justify-center' : ''}>
      <div className={!isDesktopOrLaptop ? 'select-country remove-margin' : 'select-country'}>
        <span>{props.t('global.title.location_of_residence')}</span>
        <Tooltip title={props.t("global.text.we_use_your_location_to_show_the_correct_terms_and_notices")}>
          <InfoCircleOutlined style={{paddingTop:'2px', color:"#696F88"}}/>
        </Tooltip>
      </div>
      <Select
        className={!isDesktopOrLaptop ? 'select-country-dropdown remove-margin' : 'select-country-dropdown'}
        dropdownClassName="select-country-dropdown-list-container"
        onChange={props.onCountrySelect}
        placeholder={props.t('global.text.select_a_country')}
        suffixIcon={<SearchOutlined />}
        style={{ width: '80%' }}
        showSearch
        filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
        defaultValue={props.currentCountry}
      >
        {
          AppConstants.SUPPORTED_COUNTRIES.map((supportedCountry: any) => (
            <Option key={supportedCountry.name} value={supportedCountry.value}>{supportedCountry.name}</Option>
          ))
        }
      </Select>
    </div>
  )
}

